<template>
  <!-- <v-touch @swipeleft="swiperleft" @swiperight="swiperight" class="frame"> -->
  <div class="container-box">
    <!-- 顶部 -->
    <div class="header">
      <tabBar class="tabBarStyle"></tabBar>
    </div>
    <!-- 内容 -->
    <div class="content">
      <div class="headerChild">
        <img src="../../assets/bg3.png" style="height: 200px; width: 100%" />
      </div>
      <div class="tabBarFontFrame">
        <!-- <div class="tabBarFont">
						<span>{{ tabBarTitle }}</span>
					</div> -->
        <div class="tabBarFont1">
          <span>{{ tabBarTitle1 }}</span>
        </div>
      </div>
      <div style="height: 100px; padding: 20px; color: #9d9794">
        <p>CONTACT US</p>
        <h3 style="color: #1d263d; margin-top: 6px">联系我们</h3>
      </div>
      <div class="contentChild">
        <div class="contentAddress">
          <div
            class="addressChild"
            v-for="(item, index) in list"
            :key="index"
            :class="{ border: index == 0 }"
          >
            <div class="addressImg">
              <img :src="item.img" class="imgStyle" />
            </div>
            <div class="addressFont">
              <div style="margin-bottom: 10px;">{{ item.name }}</div>
              <div>{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>
      <amap></amap>
    </div>
    <!-- 底部 -->
    <!-- <div class="footer"> -->
    <!-- <div class="footerTop">
					<div>
						<div><img src="../../assets/jiulei.jpg" style="height: 80px; width: 80px;" /></div>
						<el-button type="text" class="elBtn">酒类专营店</el-button>
					</div>
					<div>
						<div><img src="../../assets/shiping.jpg" style="height: 80px; width: 80px;" /></div>
						<el-button type="text" class="elBtn">食品专营店</el-button>
					</div>
					<div>
						<div><img src="../../assets/youping.jpg" style="height: 80px; width: 80px;" /></div>
						<el-button type="text" class="elBtn">山哩优品店</el-button>
					</div>
					<div>
						<div><img src="../../assets/douying.jpg" style="height: 80px; width: 80px;" /></div>
						<el-button type="text" class="elBtn">山哩抖音店</el-button>
					</div>
				</div> -->
    <!-- <div class="footerFrame">
					<div class="footerTitle">
						<span>{{ footerFrameFont }}</span>
					</div>
					<div class="footerContent">
						<span>{{ footerFrameFont1 }}</span>
					</div>
				</div> -->
    <!-- </div> -->
    <fixedBottomRight
      style="opacity: 1; transform: translateY(0)"
    ></fixedBottomRight>
  </div>
  <!-- </v-touch> -->
</template>

<script>
import tabBar from "../../assembly/tabBarNew.vue";
import swiper from "../../assembly/mobileSwiper.vue";
import amap from "../../assembly/amap.vue";
import fixedBottomRight from "@/assembly/fixedBottomRight.vue";
export default {
  name: "contactUs",
  data() {
    return {
      tabBarTitle: "新消费智慧供应链生态运营平台",
      tabBarTitle1: "专业化 精细化 特色化 新颖化",
      footerFrameFont: "山哩数智科技有限公司",
      footerFrameFont1: "SHANLI HOLDING TECHNOLOGY",
      list: [
        {
          img: require("@/assets/iphones.png"),
          name: "电话",
          content: "4006665230",
        },
        {
          img: require("@/assets/address.png"),
          name: "地址",
          content: "贵州省贵阳市南明区财富广场6号",
        },
        {
          img: require("@/assets/email.png"),
          name: "邮箱",
          content: "ShanLiCPB@163.com",
        },
      ],
    };
  },
  components: {
    tabBar,
    swiper,
    amap,
    fixedBottomRight,
  },
  methods: {
    swiperleft() {
      /* this.$router.push({
					name: 'index'
				}) */
    },
    swiperight() {
      /* this.$router.push({
					name: 'journalism'
				}) */
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

// .frame {
// 	position: absolute;
// 	height: 100%;
// 	width: 100%;
// 	touch-action: pan-y !important;
// }

.container-box {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f6f6f6;

  .imgStyle {
    height: 100%;
    width: 100%;
  }

  .header {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: fixed;
    background-color: #fff;
    height: 7.5vh;
    width: 100%;
    z-index: 999;

    .headerChild {
      height: 59%;
      width: 100vw;
    }
  }

  .content {
    margin-top: 7.5vh;
    margin-bottom: 10vh;
    width: 100vw;
    height: 65vh;
    .contentChild {
      background: #ffffff;
      display: flex;
      flex-direction: column;
      margin: 0 20px 20px 20px;
      border-radius: 6px;
      // 居中
      // justify-content: center;
      align-items: center;
      padding: 0.5rem;

      .contentAddress {
        height: 80%;
        width: 100%;

        .addressChild {
          display: flex;
        //   padding: 0.3rem 0.3rem 0 0.3rem;
          font-size: 15px;
		  padding: 30px 0;
		  color: #1d263d;
          .addressImg {
            margin: 0 0.5rem;
            height: 1.6rem;
            width: 1.6rem;
          }

          .addressFont {
            letter-spacing: 2px;
            margin: 0 0.5rem;
          }
        }
      }
    }
  }
  .border {
    border-bottom: solid 1px gainsboro;
  }
  .footer {
    padding-top: 20px;
    z-index: 999;
    position: fixed;
    bottom: 0;
    height: 10vh;
    width: 100vw;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    .footerTop {
      margin: 0 2rem;
      display: flex;
      justify-content: space-between;
    }

    .elBtn {
      color: black;
      font-weight: bold;
      letter-spacing: 2px;
    }

    .footerFrame {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 8vh;
      color: #7b0000;
    }

    .footerTitle {
      font-size: 0.1rem;
      font-weight: bolder;
      letter-spacing: 3px;
    }

    .footerContent {
      margin-top: 0.2rem;
      font-size: 0.1rem;
    }
  }
}
.tabBarFontFrame {
  pointer-events: none;
  color: #fff;
  height: 5vh;
  width: 100%;
  position: absolute;
  top: 17vh;
  z-index: 3;
  display: flex;
  align-items: center;
  flex-direction: column;

  .tabBarFont {
    letter-spacing: 2px;
    font-weight: 600;
    font-size: 16px;
  }

  .tabBarFont1 {
    margin-top: 2%;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 2px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/iphone/contactUs.vue